import React, {Suspense} from 'react';
import {Route, Routes} from 'react-router-dom';
import CabinetLayout from "#app/pagesRouter/CabinetLayout";

import {
    Analytics,
    Cabinet,
    Cohort,
} from './LazyLoadedPages';
import UnexpectedError from "#app/interface/error/UnexpectedError";

const CabinetRoutes = ({ logout, ...props }) => {
    return (
        <Routes>
            <Route element={<CabinetLayout/>}>
                <Route path="/error" element={<UnexpectedError />} />
                <Route path="" element={<Suspense><Cabinet {...props} /></Suspense>} />
                <Route path="/cohort" element={<Suspense><Cohort {...props} /></Suspense>} />
                <Route path="/analytics" element={<Suspense><Analytics {...props} /></Suspense>} />
                <Route path="/support" element={<Suspense><Cabinet {...props} /></Suspense>} />
            </Route>
        </Routes>
    );
};

export default CabinetRoutes;